/**
 * TypeScript view of the `semantic_word` format (ADR 0041).
 * Source of truth: `shared/schema/semantic_word.{definition,submission,progress}.json`.
 */

export type Localized = Record<string, string | undefined>;
export type Language = "fr" | "en";

export const LANGUAGES: Language[] = ["fr", "en"];
export const DEFAULT_TOP_RANK = 1000;

export interface SemanticWordDefinition {
  puzzleType: "semantic_word";
  typeVersion: number;
  language: Language;
  /** Word-vector file under shared/embeddings/, without extension. Defaults to the language. */
  vocabulary?: string;
  /** A guess among the topRank nearest words also gets its rank (1 = nearest). */
  topRank?: number;
  rulesText?: Localized;
  meta?: Record<string, unknown>;
}

/** One graded guess. `rank` is null beyond `topRank`; the found word has rank 0. */
export interface Guess {
  word: string;
  /** Cosine × 100, two decimals; 100 for the found word. */
  similarity: number;
  rank: number | null;
}

/** Autosave shape. Opaque to the core; this type owns it and its migrations. */
export interface SemanticWordProgress {
  version: 1;
  /** The word being typed. */
  draft: string;
  /** Every graded guess, in submission order. */
  guesses: Guess[];
  /** Words the server refused as unknown, so the player is told without a transient state. */
  unknown?: string[];
}

export interface SemanticWordSubmission {
  word: string;
}

export function topRankOf(definition: SemanticWordDefinition): number {
  return definition.topRank ?? DEFAULT_TOP_RANK;
}
